import { render, staticRenderFns } from "./BookingView.vue?vue&type=template&id=45be6900&scoped=true"
import script from "./BookingView.vue?vue&type=script&lang=js"
export * from "./BookingView.vue?vue&type=script&lang=js"
import style0 from "./BookingView.vue?vue&type=style&index=0&id=45be6900&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be6900",
  null
  
)

export default component.exports